var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { attrs: { id: "header-section" } },
    [
      !_vm.isLineLoggedIn
        ? _c(
            "div",
            { staticClass: "customer-service-header", class: _vm.hidden },
            [_vm._m(0)]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("MenuBar", {
        attrs: {
          user: _vm.user,
          isLineLoggedIn: _vm.isLineLoggedIn,
          flagImage: _vm.flagImage,
          hidden: _vm.hidden,
          hiddenWhenBooking: _vm.hiddenWhenBooking,
          newInbox: _vm.newInbox,
          inboxMessages: _vm.inboxMessages,
          isFetchingMessage: _vm.isFetchingMessage,
          notifications: _vm.notifications,
          isFetchingNoti: _vm.isFetchingNoti
        },
        on: {
          openLogoutDialog: _vm.$parent.openLogoutDialog,
          openModal: function($event) {
            return _vm.$parent.openModal($event)
          },
          setLocaleLanguage: function($event) {
            return _vm.$parent.setLocaleLanguage($event)
          },
          convertUrl: function($event) {
            return _vm.convertUrl($event)
          },
          hasReadMessage: function($event) {
            return _vm.hasReadMessage($event)
          },
          convertTimespan: function($event) {
            return _vm.convertTimespan($event)
          },
          showPicture: function($event) {
            return _vm.showPicture($event)
          },
          hasReadActivity: function($event) {
            return _vm.hasReadActivity($event)
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "progress", class: _vm.progressDisplay }, [
        _c("div", {
          staticClass: "progress-bar",
          style: "width:" + (_vm.state.currentStep / 3) * 100 + "%"
        })
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 p-xl-0 p-sm-2 small" }, [
        _vm._v("\n        Customer Service  \n        "),
        _c("i", { staticClass: "fas fa-phone" }),
        _vm._v(" "),
        _c("a", { attrs: { href: "tel:+6621131138" } }, [
          _vm._v("02-113-1138")
        ]),
        _vm._v(",\n        "),
        _c("a", { attrs: { href: "tel:+66927572999" } }, [
          _vm._v("092-757-2999")
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61dd7a3d", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61dd7a3d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 1440
// module chunks = 0